var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#55217E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_756_60672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.75 27.664L26.293 31.121C25.734 31.68 24.961 32 24.172 32H24V31.828C24 31.039 24.32 30.266 24.879 29.707L28.336 26.25L29.75 27.664ZM30.793 23.793L29.75 24.836L31.164 26.25L32.207 25.207C32.597 24.817 32.597 24.183 32.207 23.793C31.817 23.403 31.184 23.402 30.793 23.793ZM40 28C40 34.617 34.617 40 28 40C21.383 40 16 34.617 16 28C16 21.383 21.383 16 28 16C34.617 16 40 21.383 40 28ZM33.621 22.379C32.451 21.209 30.549 21.209 29.379 22.379L23.465 28.293C22.521 29.237 22 30.493 22 31.828V33C22 33.553 22.447 34 23 34H24.172C25.507 34 26.763 33.479 27.707 32.535L33.621 26.621C34.791 25.451 34.791 23.549 33.621 22.379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_756_60672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.21886a70.svg";
export { ForwardRef as ReactComponent };